export default __webpack_public_path__ + "static/media/phone-5.8dbc310d.svg";